import React from 'react'
import { Autocomplete, TextField, useTheme } from '@mui/material'
import { ElementProps, SxpButtonOption } from '../models'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'

const styles = (_theme: any, props: { hasError: boolean }) => ({
  fieldSet: {
    marginBottom: '2px',
  },
  wrapper: {
    width: '300px !important',
  },
  autoCompleteRoot: {
    width: '300px !important',
    marginTop: '5px',
    '& .MuiOutlinedInput-root': {
      position: 'relative',
      padding: '0 !important',
      backgroundColor: '#fff',
      borderRadius: 0,
      fontSize: 14,
      width: '300px !important',
    },
    '& .MuiAutocomplete-input': {
      width: '100% !important',
      boxSizing: 'border-box',
      padding: '2px 10px 2px 5px !important',
      height: '25px',
      margin: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: props.hasError ? 'red' : '#ddd',
      borderWidth: '1px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: props.hasError ? 'red' : '#ddd',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: props.hasError ? 'red' : '#ddd',
      borderWidth: '1px',
    },
    '& .MuiAutocomplete-endAdornment': {
      position: 'absolute',
      right: '20px !important',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
      width: '0px !important',
    },
    '& .MuiAutocomplete-popupIndicator': {
      padding: '1px',
      marginRight: '30px !important',
    },
    '& .MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root': {
      width: '300px !important',
    },
    '& .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.MuiAutocomplete-clearIndicator':
      {
        display: 'none !important',
      },
  },
  popper: {
    width: '300px !important',
  },
  paper: {
    width: '300px !important',
  },
  listbox: {
    width: '300px !important',
    boxSizing: 'border-box',
  },
})

const ButtonField = ({
  component,
  state,
  handleChange,
  disabled,
  errorMessage,
}: ElementProps) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme, {
    hasError: Boolean(errorMessage),
  })
  const selectedValue = state[component.reference]
  const normalizedSelectedValue =
    selectedValue === null || selectedValue === undefined
      ? ''
      : String(selectedValue)

  const selectedOption =
    component.options.find(
      (d: SxpButtonOption) => String(d?.value) === normalizedSelectedValue
    ) || null
  return (
    <div className={`fieldSet ${classes?.fieldSet}`}>
      <FieldLabel label={component?.label} required={component?.required} />
      <div className={classes?.wrapper}>
        <Autocomplete
          disablePortal
          options={component?.options}
          value={selectedOption}
          getOptionLabel={(option) => option?.label || ''}
          isOptionEqualToValue={(option, value) =>
            String(option?.value) === String(value?.value)
          }
          onChange={(_, newValue) =>
            handleChange(newValue?.value || '', component)
          }
          componentsProps={{
            popper: { className: classes?.popper },
            paper: { className: classes?.paper },
          }}
          ListboxProps={{ className: classes.listbox }}
          disabled={disabled}
          className={classes.autoCompleteRoot}
          renderInput={(params) => (
            <TextField
              {...params}
              name={component?.reference}
              placeholder={component?.placeHolder || 'Select an option'}
              error={Boolean(errorMessage)}
            />
          )}
        />
        <ErrorMessage errorMessage={errorMessage} />
      </div>
    </div>
  )
}

export default ButtonField
